import {
  Anticipation,
  Plan,
} from 'commons/services/configurationService/configurationServiceResponses';
import { PaymentMethodsType } from 'commons/types';

interface PlanFee {
  paymentMethod: PaymentMethodsType;
  settlementPeriod: number;
  transactionFee: number;
  fixedFee: number;
}

const createDefaultPlanFee = (paymentMethod: PaymentMethodsType): PlanFee => ({
  paymentMethod,
  settlementPeriod: 0,
  transactionFee: 0,
  fixedFee: 0,
});

const getPaymentMethodFees = (
  plan: Plan,
  paymentMethod: PaymentMethodsType,
): PlanFee => {
  const anticipations = plan.anticipations.filter((anticipation) => {
    return anticipation.paymentMethod === paymentMethod;
  });

  if (!anticipations.length) {
    return createDefaultPlanFee(paymentMethod);
  }

  const settlementPeriodAnticipation = getLowerSettlementPeriod(anticipations);
  const transactionFee = getLowerInstallmentFee(settlementPeriodAnticipation);
  const fixedFee = settlementPeriodAnticipation.fixedFee ?? 0;

  return {
    paymentMethod,
    settlementPeriod: settlementPeriodAnticipation.settlementPeriod,
    transactionFee: Number(transactionFee),
    fixedFee,
  };
};

const getLowerSettlementPeriod = (
  anticipations: Anticipation[],
): Anticipation => {
  return anticipations.reduce((min, anticipation) => {
    return anticipation.settlementPeriod < min.settlementPeriod
      ? anticipation
      : min;
  }, anticipations[0]);
};

const getLowerInstallmentFee = (anticipation: Anticipation) => {
  if (!anticipation.installments?.length) {
    return 0;
  }

  return (
    Math.min(
      ...anticipation.installments.map((installment) => installment.fee),
    ) * 100
  ).toFixed(2);
};

export const feePlansMapper = (
  plan: Plan,
  paymentMethods: PaymentMethodsType[],
): PlanFee[] => {
  return paymentMethods
    .map((paymentMethod) => getPaymentMethodFees(plan, paymentMethod))
    .filter(Boolean);
};
